export default "/static/dashboard/build/app/img/v2/0991028c7cdcd0361fc32c035b2b353d.png";